import React, { useState, useEffect } from "react";
import Pagination from "react-bootstrap/Pagination";
import "bootstrap/dist/css/bootstrap.css";

export function AdvancedExample({ totalPages, selectedPage, onPageSelected }) {
  const [activePage, setActivePage] = useState(selectedPage);

  useEffect(() => {
    setActivePage(selectedPage);
  }, [selectedPage]);

  const handlePageClick = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) {
      return;
    } else {
      setActivePage(pageNumber);
      onPageSelected(pageNumber); // Chama a função de retorno com o número da página selecionada
    }
  };

  const generatePageNumbers = () => {
    const pageNumbers = [];

    const maxVisiblePages = 5; // Define o número máximo de páginas visíveis
    let startPage = Math.max(1, activePage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item
          key={i}
          onClick={() => handlePageClick(i)}
          active={activePage === i}
        >
          {i}
        </Pagination.Item>
      );
    }

    return pageNumbers;
  };

  return (
    <div>
      <Pagination>
        <Pagination.First onClick={() => handlePageClick(1)} disabled={activePage === 1} />
        <Pagination.Prev
          onClick={() => handlePageClick(activePage - 1)}
          disabled={activePage === 1}
        />
        {generatePageNumbers()}
        <Pagination.Next
          onClick={() => handlePageClick(activePage + 1)}
          disabled={activePage === totalPages}
        />
        <Pagination.Last onClick={() => handlePageClick(totalPages)} disabled={activePage === totalPages} />
      </Pagination>
    </div>
  );
}
